// extracted by mini-css-extract-plugin
export default {"tabContent":"ContactDetail_tabContent__ITPYk","tabItem":"ContactDetail_tabItem__8X-VN"};